import Component from 'flarum/common/Component';
import { heroView } from '../../common/heroView';

/**
 * Thin Mithril wrapper around the shared hero renderer. The forum passes a
 * fully-resolved config (see resolve.ts); the markup itself lives in heroView so
 * the admin Hero Studio live preview stays pixel-identical.
 */
export default class HeroBanner extends Component {
  view() {
    return heroView(this.attrs.cfg);
  }
}
flarum.reg.add('ernestdefoe-hero-builder', 'forum/components/HeroBanner', HeroBanner);